'use es6';

function loadScript(url, onLoad, onError) {
  var scriptElement = document.createElement('script');

  if (onError) {
    scriptElement.onerror = onError;
  }

  if (onLoad) {
    scriptElement.onload = onLoad;
  }

  document.head.appendChild(scriptElement);
  scriptElement.src = url;
}

export function loadWistiaApi() {
  loadScript('//fast.wistia.net/assets/external/E-v1.js');
}
export function loadVidyardApi(onLoad, onError) {
  loadScript('//play.vidyard.com/embed/v4.js', onLoad, onError);
}